// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.maintenance.properties.RentalManagerUserMaintenancePropertiesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerUserMaintenancePropertyListDto } from '../..';

export const RentalManagerUserMaintenancePropertiesWebApiHandler_list_Path =
  '/api/web/v1/users/maintenance/properties/list';

/**
 * Get list of properties for user to create maintenance tasks
 */
export const RentalManagerUserMaintenancePropertiesWebApiHandler_list = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserMaintenancePropertyListDto>(
    {
      endpoint: RentalManagerUserMaintenancePropertiesWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
